var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasketBall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "v0mzjyugsa",
    d: "M0 0L20.672 0 20.672 12.691 0 12.691z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#003DB3",
    d: "M10.351 20.7c-1.44 0-2.836-.293-4.152-.87-1.364-1.55-2.278-3.27-2.723-5.116.815.283 1.584.788 2.46 1.364 1.941 1.276 4.357 2.863 8.681 2.863.517 0 1.055-.023 1.608-.069-1.733 1.199-3.749 1.828-5.874 1.828m-5.854-1.816c-1.468-1.01-2.672-2.397-3.453-3.992.316-.27.721-.407 1.205-.407.13 0 .266.009.408.028.326 1.554.944 3.02 1.84 4.37m10.137-.724c-4.109 0-6.317-1.45-8.266-2.73-1.062-.699-1.984-1.305-3.064-1.582-.054-.34-.094-.69-.117-1.04 1.79.484 3.891.74 6.098.74.37 0 .743-.007 1.12-.022 4.364-.166 8.08-1.222 10.295-2.91-.062 2.784-1.27 5.448-3.334 7.348-.956.13-1.875.196-2.732.196M.717 14.157c-.332-.84-.55-1.72-.65-2.628.663.403 1.446.754 2.338 1.045.02.382.057.763.111 1.14-.094-.008-.187-.011-.277-.011-.586 0-1.097.152-1.522.454"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "6in28j0v1b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v0mzjyugsa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B0F0FF",
    d: "M9.235 12.691c-2.231 0-4.327-.265-6.076-.767 0-.619.048-1.25.141-1.882.282.044.572.066.865.066 2.578 0 5.27-1.69 7.873-3.324 2.086-1.31 4.238-2.66 6.253-3.084 1.399 1.666 2.22 3.681 2.38 5.84-2.11 1.916-6.583 3.151-11.436 3.151m-6.845-1.01c-.947-.333-1.748-.737-2.386-1.207C.002 10.42 0 10.363 0 10.306 0 8.26.592 6.311 1.72 4.623l-.066.388c-.302 1.755-.713 4.137.887 4.833-.093.612-.144 1.228-.15 1.836M4.16 9.33c-.246 0-.49-.018-.724-.054.123-.597.288-1.193.49-1.772C5.197 3.84 8.007.69 10.614 0c2.686.067 5.184 1.144 7.074 3.041-2.01.537-4.068 1.83-6.063 3.081C9.112 7.7 6.518 9.33 4.161 9.33M2.69 9.03c-.83-.603-.518-2.413-.264-3.888.11-.636.213-1.237.212-1.703C4.167 1.735 6.184.6 8.402.178c-2.198 1.437-4.184 4.1-5.215 7.07-.205.59-.372 1.188-.498 1.783",
    mask: "url(#6in28j0v1b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketBall);
export default __webpack_public_path__ + "static/media/basketBall.65f68cfc0adaa6db7abd3526c8496cdc.svg";
export { ForwardRef as ReactComponent };